<template>
  <v-card-text>
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="d-flex align-center ga-3 flex-wrap">
        <div class="d-flex align-center ga-1">
          <span class="text-disabled font-size-14">Виявлено недоліків:</span>
          <b>{{ issues.length }}</b>
        </div>
      </div>

      <v-btn
        v-if="canCreateIncidentIssue"
        :disabled="!riskAssessments.length"
        :loading="$loading.isLoading('incidentIssueCreate')"
        color="black"
        rounded="lg"
        @click="incidentIssueCreate">
        <v-icon class="mr-2" icon="mdi-plus"></v-icon>
        <span>Додати недолік</span>
      </v-btn>
    </div>

    <b-section-loader :loading="$loading.isLoading('incidentIssueList')">
      <div v-if="issues.length">
        <issue-item
          v-for="(issue, idx) in issues"
          :key="issue.id"
          :index="idx"
          :issue="issue"
          class="mb-3"></issue-item>
      </div>

      <div v-else class="d-flex flex-column align-center py-12">
        <search-icon class="mb-5"></search-icon>
        <h2 class="mb-3">Недоліків не зафіксовано</h2>
        <div v-if="!riskAssessments.length" class="font-size-14">
          Щоб додати недолік, спочатку додайте оцінку ризику.
        </div>
        <div v-else class="font-size-14">
          Натисніть «Додати недолік» для внесення першого запису.
        </div>
      </div>
    </b-section-loader>
  </v-card-text>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { BSectionLoader } from 'best-modules/components'
import SearchIcon from '@/assets/images/SearchIcon.vue'
import { useIncident } from '../Incident'
import IssueItem from './issues/IssueItem.vue'
import { fillDirectory } from '@/directory'

defineOptions({
  name: 'IncidentIssues',
})

const { canCreateIncidentIssue, issues, incidentIssueCreate, riskAssessments } =
  useIncident()

onMounted(() => {
  fillDirectory('incidentIssueStatuses')
})
</script>
